import * as angular from 'angular';

"use strict";

angular.module('ScanStationModule', [])

export default 'ScanStationModule';